export type NotificationWidgetVariant = 'row' | 'square'

export type NotificationWidget = 'profile' | 'wallets' | 'txs'
export type NotificationCenterSharedWidget =
  | 'walletTracker'
  | 'premium'
  | 'notifications'
  | 'support'

export type NotificationCenterWidget =
  | NotificationWidget
  | NotificationCenterSharedWidget

export type PnlTrend = 'up' | 'down' | 'neutral'

export const getPnlTrend = (value: number | undefined): PnlTrend => {
  if (value === undefined || value === 0) {
    return 'neutral'
  }

  return value > 0 ? 'up' : 'down'
}
